import { goBack } from "assets/icons";
import styled from "@emotion/styled";
import { Card, Col, Form, message, Row, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import MainCreateShipping from "./MainCreateShipping";
import {
  useCreateTransportationConfigs,
  useGetTransportationTypeByFactory,
} from "hooks/useFactory";
import CreateShippingFooter from "./CreateShippingFooter";
import {
  CreateGeographyInput,
} from "services/interface";
import { useAppSelector } from "store";
import { useGetMasterGeography } from "hooks/useMasterData";

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 12 },
    sm: { span: 6 },
  },
};
const CreateShipping = () => {
  const factoryId = useAppSelector(
    (state) => state.auth.profile?.user?.role?.ref_id
  );

  const navigate = useNavigate();

  const { data: dataTransportation } = useGetTransportationTypeByFactory(
    factoryId || ""
  );

  const [form] = Form.useForm();

  const { data: dataGeography } = useGetMasterGeography();

  const { mutate: CreateTransportConfis } = useCreateTransportationConfigs();
  const onFinish = (values: any) => {
    console.log("values---->>>", values);


    let geography_id: number | null = null
    if (values.geolocation_type === "geolocation") {
      geography_id = values.geolocation_key
    } else if (values.geolocation_type === "province") {
      geography_id = null
    } else {
      geography_id = 7
    }

    let lessList: any[] = []

    if (values.free_shipping !== true) {
       lessList = values?.transportRate?.map((item: any) => {
        return {
          factoty_id: factoryId ?? "",
          geography_id: geography_id,
          condition_config: "less",
          transport_type: values?.transportation_key,
          transport_rate: parseInt(item?.totalPrice, 10) || 0,
          service_price: parseInt(item?.transportPrice, 10) || 0,
          remark: values?.remark,
          province_id: values?.province,
          district_id: values?.district,
        }
      })
    } else {
      lessList = [
        {
          factoty_id: factoryId ?? "",
          geography_id: geography_id,
          condition_config: "less",
          transport_type: values?.transportation_key,
          transport_rate: 0,
          service_price: 0,
          province_id: values?.province,
          district_id: values?.district,
        }
      ]
    }

    const more_then = {
      factoty_id: factoryId ?? "",
      geography_id: geography_id,
      condition_config: "more_then",
      transport_type: values?.transportation_key,
      // last of array values.transportRate
      transport_rate: values?.transportRate
        ? parseInt(values?.transportRate[values?.transportRate?.length - 1]?.totalPrice, 10) || 0
        : 0,
      service_price: values?.more_then_service_price
        ? parseInt(values?.more_then_service_price, 10) || 0
        : 0,
      remark: values?.remark,
      province_id: values?.province,
      district_id: values?.district,
    };

    const dataRaw: CreateGeographyInput = {
      is_free: values?.free_shipping,
      config_list: [...lessList, more_then],
    };

    console.log("dataRaw Transport create", dataRaw);

    CreateTransportConfis(dataRaw, {
      onSuccess: (res) => {
        if (res.status === "success") {
          message.success("สร้างค่าจัดส่งสำเร็จ");
          navigate(`/manage-shipping`);
        } else {
          message.error(`สร้างค่าจัดส่งไม่สำเร็จ: ${res.error_message}`);
        }
      },
      onError: (error) => {
        message.error(`สร้างค่าจัดส่งไม่สำเร็จ: ${error.message}`);
      },
    });
  };

  return (
    <Form
      form={form}
      onFinish={onFinish}
      initialValues={{
        transportRate: [{ totalPrice: "", transportPrice: "" }],
      }}
    >
      <Row className="rowgap-vbox" gutter={[24, 0]} style={{ height: "100%" }}>
        <Col span={24}>
          <Card bordered={false} className="criclebox h-full tabs-mobile">
            <HeaderTabs>
              <IconWrapper
                onClick={() => {
                  navigate("/manage-shipping");
                }}
              >
                <SpanIcon>{goBack}</SpanIcon>
              </IconWrapper>
              <Typography.Title level={5}>เพิ่มค่าจัดส่ง</Typography.Title>
              <RightIconWrapper></RightIconWrapper>
            </HeaderTabs>
            <WrapperAll>
              <Row>
                <Col sm={0} md={6}></Col>
                <Col sm={24} md={12}>
                  <MainCreateShipping
                    data={dataTransportation?.data}
                    form={form}
                    dataGeography={dataGeography}
                    is_free={false}
                  />
                </Col>
                <Col sm={0} md={6}></Col>
              </Row>
            </WrapperAll>
          </Card>
        </Col>
      </Row>
      <CreateShippingFooter />
    </Form>
  );
};

export default CreateShipping;

const HeaderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-direction: row;
  border-bottom: 1px solid #efefef;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const RightIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const WrapperAll = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;
// height: 500px;
